var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocketLaunch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.992 11.9747C13.079 12.344 13.125 12.7291 13.125 13.125C13.125 15.8864 10.8864 18.125 8.125 18.125V14.1253M12.992 11.9747C16.1037 9.70093 18.125 6.02395 18.125 1.875C13.9762 1.87518 10.2996 3.89655 8.02602 7.00813M12.992 11.9747C11.5682 13.0151 9.91615 13.7617 8.125 14.1253M8.02602 7.00813C7.65648 6.92106 7.27112 6.875 6.875 6.875C4.11358 6.875 1.875 9.11358 1.875 11.875H5.8756M8.02602 7.00813C6.98571 8.43189 6.23917 10.0839 5.8756 11.875M8.125 14.1253C8.03882 14.1428 7.95233 14.1594 7.86552 14.1751C7.10976 13.5758 6.42492 12.891 5.82566 12.1352C5.84141 12.0482 5.85806 11.9614 5.8756 11.875M4.00992 13.8673C3.09345 14.551 2.5 15.6437 2.5 16.875C2.5 17.0724 2.51525 17.2662 2.54464 17.4554C2.73379 17.4848 2.92761 17.5 3.125 17.5C4.35631 17.5 5.44902 16.9066 6.1327 15.9901M13.75 7.5C13.75 8.19036 13.1904 8.75 12.5 8.75C11.8096 8.75 11.25 8.19036 11.25 7.5C11.25 6.80964 11.8096 6.25 12.5 6.25C13.1904 6.25 13.75 6.80964 13.75 7.5Z",
    stroke: "#ffffff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketLaunch);
export default __webpack_public_path__ + "static/media/rocket-launch.d0cc1b4279db9d03e3d9e1060684b00e.svg";
export { ForwardRef as ReactComponent };